import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import findResult, { removeEmpty } from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import useDebounce from '@/utils/debounce';
import {
  addCollectionDatasetsAssignable,
  fetchCollectionDatasetsAssignable,
  updateCollectionDatasetsAssignableProperties,
  updateCollectionUnassignedDatasetsProperties,
} from '../actions';
import CollectionDatasetsAssignAddRow from '../components/CollectionDatasetsAssignAddRow';

const CollectionDatasetAddRow = ({
  category,
  code,
  datasets,
  datasetsToAdd,
  fetchData,
  updateFilter,
  updateProperties,
  addDatasets,
  readStatus,
  filter,
}) => {
  const debouncedFetch = useDebounce(fetchData);

  const datasetsToAddChange = (value) => {
    const items = removeEmpty(value.map((c) => datasets.find((item) => item.code === c)));
    updateProperties({ datasetsToAdd: items });
  };

  const onFilterChange = useCallback((value) => {
    updateFilter(category, code, value);
    debouncedFetch(category, code, value);
  }, [category, code, updateFilter, debouncedFetch]);

  return (
    <CollectionDatasetsAssignAddRow
      readStatus={readStatus}
      filter={filter}
      datasets={datasets}
      addDatasets={() => addDatasets(category, code)}
      onFilterChange={onFilterChange}
      datasetsToAdd={datasetsToAdd}
      datasetsToAddChange={datasetsToAddChange}
    />
  );
};

const dialogProps = (datasetAssigningCollection, exists, datasets = []) => (
  {
    exists,
    datasetsToAdd: datasetAssigningCollection.datasetsToAdd,
    datasets,
  }
);

const withoutItem = (datasetAssigningCollection) => (
  {
    ...dialogProps(datasetAssigningCollection, false),
    ...readStates,
    filter: '',
  }
);

const withItem = (item, datasetAssigningCollection) => {
  const assignable = item.unassignedDatasets.results;

  return (
    {
      ...dialogProps(datasetAssigningCollection, true, assignable),
      readStatus: item.unassignedDatasets.readStatus,
      readErrors: item.unassignedDatasets.readErrors,
      filter: item.unassignedDatasets.filter,
    }
  );
};

const mapStateToProps = ({
  collectionDatasets: {
    collectionDatasets,
    datasetAssigningCollection,
  },
}, { category, code }) => {
  const item = findResult(collectionDatasets, category, code);
  return item ? withItem(item, datasetAssigningCollection) : withoutItem(datasetAssigningCollection);
};

const mapDispatchToProps = {
  addDatasets: addCollectionDatasetsAssignable,
  fetchData: fetchCollectionDatasetsAssignable,
  updateFilter: (category, code, filter) => updateCollectionUnassignedDatasetsProperties(category, code, { filter }),
  updateProperties: updateCollectionDatasetsAssignableProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDatasetAddRow);
